import './style/index.js';

import _StickyTool from './StickyTool';

export type { StickyItemProps } from './StickyItem';
export type { StickyToolProps } from './StickyTool';
export * from './type';

export const StickyTool = _StickyTool;
export default StickyTool;
